import { Outlet } from 'react-router';

const SolveLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Outlet />
    </div>
  );
};

export default SolveLayout;
